<template>
  <v-main>
    <slot />
  </v-main>
</template>
